var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgIcLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.22202 19.778C4.6859 20.2425 5.23699 20.6108 5.84364 20.8617C6.45029 21.1126 7.10054 21.2412 7.75702 21.24C8.41365 21.2411 9.06404 21.1126 9.67085 20.8617C10.2777 20.6108 10.8289 20.2425 11.293 19.778L14.121 16.949L12.707 15.535L9.87902 18.364C9.31549 18.925 8.55269 19.24 7.75752 19.24C6.96235 19.24 6.19955 18.925 5.63602 18.364C5.07453 17.8007 4.75923 17.0378 4.75923 16.2425C4.75923 15.4472 5.07453 14.6843 5.63602 14.121L8.46502 11.293L7.05102 9.879L4.22202 12.707C3.28583 13.6455 2.76007 14.9169 2.76007 16.2425C2.76007 17.5681 3.28583 18.8395 4.22202 19.778V19.778ZM19.778 11.293C20.7137 10.3543 21.2392 9.08292 21.2392 7.7575C21.2392 6.43208 20.7137 5.16072 19.778 4.222C18.8396 3.28581 17.5681 2.76005 16.2425 2.76005C14.9169 2.76005 13.6455 3.28581 12.707 4.222L9.87902 7.051L11.293 8.465L14.121 5.636C14.6846 5.07499 15.4474 4.76003 16.2425 4.76003C17.0377 4.76003 17.8005 5.07499 18.364 5.636C18.9255 6.19927 19.2408 6.96217 19.2408 7.7575C19.2408 8.55283 18.9255 9.31573 18.364 9.879L15.535 12.707L16.949 14.121L19.778 11.293Z",
    fill: "#008CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46401 16.95L7.04901 15.536L15.536 7.05L16.95 8.465L8.46401 16.95Z",
    fill: "#008CFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLink);
export default __webpack_public_path__ + "static/media/ic-link.256d78d400df8f6f4fcac6cb4afa356f.svg";
export { ForwardRef as ReactComponent };